<app-custom-button
  (buttonClick)="toggleAvatar()"
  [icon]="talkingAvatarService.isClosed ? 'face' : 'face_retouching_natural'"
  [tooltip]="getTooltipText()"
  [active]="!talkingAvatarService.isClosed"
  variant="filled"
></app-custom-button>
